import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import constants from '../../utility/constants';

@Component({
  selector: 'app-account-deactive',
  templateUrl: './account-deactive.component.html',
  styleUrls: ['./account-deactive.component.css'],
})
export class AccountDeactiveComponent implements OnInit {
  serviceEmail: string = constants.common.clientMail.clientServiceEmail;
  email: string = '';
  constructor(
    public modalRef: BsModalRef,
    public router: Router,
    public ar: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.ar.params.subscribe((res) => {
      this.email = res.email;
    });
  }

  hideAndReset() {
    this.modalRef.hide();
  }
}
